"use strict";

exports.__esModule = true;
exports.formatPlantName = exports.SwitchPlant = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFinalForm = require("react-final-form");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _FormGroupField = require("../../Form/FormGroupField");
var _Heading = require("../../Core/Heading");
var _Translator = require("../../Core/Translator");
var _class, _SwitchPlant;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var STORAGE_CURRENT_PLANT_KEY = "vi-current-plant";
var SwitchPlantHeader = _styledComponents["default"].div.withConfig({
  displayName: "SwitchPlant__SwitchPlantHeader",
  componentId: "sc-1k39nx1-0"
})(["display:flex;flex-direction:row;"]);
var CloseIcon = (0, _styledComponents["default"])(_core.Icon).withConfig({
  displayName: "SwitchPlant__CloseIcon",
  componentId: "sc-1k39nx1-1"
})(["cursor:pointer;padding:10px 0px 10px 10px;"]);
var formatPlantName = exports.formatPlantName = function formatPlantName(plantName) {
  // Remove all whitespaces and convert name to lowercase
  if (plantName) {
    return plantName.replace(/\s/g, "").toLowerCase();
  }
  return "";
};
var onSubmit = function onSubmit(values) {
  var formattedPlantName = formatPlantName(values.plantName);
  if (formattedPlantName.length > 0) {
    localStorage.setItem(STORAGE_CURRENT_PLANT_KEY, formattedPlantName);
  }
  window.location.reload();
};
var SwitchPlant = exports.SwitchPlant = (0, _Translator.withTranslator)(_class = (_SwitchPlant = /*#__PURE__*/function (_PureComponent) {
  function SwitchPlant(props) {
    var _this;
    _this = _PureComponent.call(this, props) || this;
    _this.plantInput = /*#__PURE__*/(0, _react.createRef)();
    return _this;
  }

  // Blueprint v6's `HotkeysTarget` is a hook-backed wrapper component (not a class
  // decorator like Blueprint v3's `@HotkeysTarget` + `renderHotkeys()`); both combos
  // are `global`, so a plain element (no keydown/keyup handlers) is sufficient.
  _inheritsLoose(SwitchPlant, _PureComponent);
  var _proto = SwitchPlant.prototype;
  _proto.getHotkeysConfig = function getHotkeysConfig() {
    var _this2 = this;
    return [{
      global: true,
      combo: "cmd + shift + p",
      label: "Switch plant",
      onKeyDown: function onKeyDown() {
        return _this2.handleSwitchPlantDialog(true);
      }
    }, {
      global: true,
      combo: "shift + p",
      label: "Switch plant",
      onKeyDown: function onKeyDown() {
        return _this2.handleSwitchPlantDialog(true);
      }
    }];
  };
  _proto.handleSwitchPlantDialog = function handleSwitchPlantDialog(isOpen) {
    var _this3 = this;
    this.props.setIsSwitchPlantOpen(isOpen);
    this.plantInput.blur();
    setTimeout(function () {
      if (isOpen === true) {
        _this3.plantInput.focus();
      }
    }, 0);
  };
  _proto.render = function render() {
    var _this4 = this;
    var _this$props = this.props,
      isOpen = _this$props.isOpen,
      theme = _this$props.theme,
      translator = _this$props.translator;
    var translate = translator.translate;
    return /*#__PURE__*/_react["default"].createElement(_core.HotkeysTarget, {
      hotkeys: this.getHotkeysConfig()
    }, /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
      isOpen: isOpen,
      onClose: function onClose() {
        return _this4.handleSwitchPlantDialog(false);
      },
      style: {
        padding: 0
      },
      className: theme.bodyClassName
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _core.Classes.DIALOG_HEADER,
      style: {
        display: "flex",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/_react["default"].createElement(SwitchPlantHeader, null, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      icon: _icons.IconNames.OFFICE,
      size: _core.IconSize.LARGE
    }), /*#__PURE__*/_react["default"].createElement(_Heading.Heading, {
      level: 3,
      style: {
        margin: 0
      }
    }, translate("SettingsMenu.switchPlant.title", "Switch Plant"))), /*#__PURE__*/_react["default"].createElement(CloseIcon, {
      icon: _icons.IconNames.CROSS,
      size: _core.IconSize.LARGE,
      onClick: function onClick() {
        return _this4.handleSwitchPlantDialog(false);
      }
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _core.Classes.DIALOG_BODY,
      style: {
        margin: "10px",
        transform: "scale(1.02)"
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Form, {
      onSubmit: onSubmit
    }, function (_ref) {
      var handleSubmit = _ref.handleSubmit;
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit,
        style: {
          display: "flex"
        }
      }, /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
        name: "plantName",
        style: {
          margin: 0,
          flex: 1
        }
      }, function (_ref2) {
        var input = _ref2.input;
        return /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({
          placeholder: translate("SettingsMenu.switchPlant.placeholder", "Enter plant")
        }, input, {
          large: true
          /* eslint-disable-next-line jsx-a11y/no-autofocus */,
          autoFocus: true,
          inputRef: function inputRef(input) {
            _this4.plantInput = input;
          }
        }));
      }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
        intent: _core.Intent.PRIMARY,
        type: "submit",
        "data-testid": "switch",
        text: translate("SettingsMenu.switchPlant.switch", "Switch")
      }));
    }))));
  };
  return SwitchPlant;
}(_react.PureComponent), _SwitchPlant.defaultProps = {
  translator: undefined
}, _SwitchPlant)) || _class;